<template>
    <div class="anticancer-container-list-main-item" @click="goAnticancer(dataSource)">
        <!-- 14抗癌百科 -->
        <van-image :src="dataSource.cover_img" />
        <div class="anticancer-container-list-main-item-title" v-html="dataSource.title"></div>
        <div class="anticancer-container-list-main-item-content-tips">
            {{ dataSource.intro }}
        </div>
        <div v-if="dataSource.recommend_words" class="anticancer-container-list-main-item-tags-list">
            <div v-for="(Titem, Tindex) in dataSource.recommend_words.split(',')" :key="Tindex">
                {{ Titem }}
            </div>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    name: 'Anticancer',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        isContent: {
            type: Boolean,
            default: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    computed: {
        dataSource() {
            return this.isContent ? this.dataItem.content : this.dataItem
        }
    },

    methods: {
        goAnticancer(row) {
            // Interface.footPrint1(14,row.id)
            if (this.contentType) {
              Interface.mFootPrint(row.id,67,this.contentType,1,0,0,0, row.title, this.searchText)
            } else {
              Interface.mFootPrint(row.id,14,this.contentType,1,0,0,0, row.title, this.searchText)
            }
            Interface.goLink(row.link)
           Interface.getData('get', `/course-phase/api/recommend_v2/${row.id}/view`)
        },
        getViewCount(row) {
            Interface.getData('post', `/encyclopedia-phase/api/encyclopedia_anticancer/${row}/viewCount`)
        }
    }
}
</script>

<style lang="scss" scoped>
.anticancer-container-list-main-item {
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;

    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-title {
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #222222;
        letter-spacing: 0;
        padding: 4px 12px;
    }

    &-content-tips {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #777777;
        letter-spacing: 0;
        padding: 0px 12px;
    }

    &-tags-list {
        margin: 12px 0px 0px 0px;
        padding: 0px 12px;
        div {
            display: inline-block;
            background-color: #fff9f1;
            padding: 3px 5px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #fea253;
            letter-spacing: 0;
            margin-right: 10px;
        }
    }

    /deep/ .van-image {
        .van-image__img {
            border-radius: 12px 12px 0 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/anticancer.vue